export const EXPORT_PRODUCTS_REQUEST = 'EXPORT_PRODUCTS_REQUEST';
export const exportProductsRequest = (searchTerm, appliedFilters, productIds) => ({
  type: EXPORT_PRODUCTS_REQUEST,
  searchTerm,
  appliedFilters,
  productIds,
});

export const EXPORT_PRODUCTS_COMPLETE = 'EXPORT_PRODUCTS_COMPLETE';
export const exportProductsComplete = (data) => ({
  type: EXPORT_PRODUCTS_COMPLETE,
  data,
});

export const IMPORT_PRODUCTS_REQUEST = 'IMPORT_PRODUCTS_REQUEST';
export const importProducts = (data) => ({
  type: IMPORT_PRODUCTS_REQUEST,
  data,
});
